module.exports = __webpack_public_path__ + "static/speaker-a9ec79d9e9361534cc945efae4dd79db.jpg";